export enum AccountStatementStatus {
  All = 'ALL', // Frontend only
  Open = 'OPEN',
  PartiallyPaid = 'PARTIALLY_PAID',
  Paid = 'PAID',
  Overdue = 'OVERDUE',
}
